'use client'
import { useAgentAuthDetails } from '@repo/services'
import { useTranslate } from '@repo/shared/hooks'
import { useRouter } from '@repo/shared/i18n/navigation'
import { Cookie } from '@repo/tools'
import {
  Button,
  Card,
  CenterBox,
  Col,
  Icon,
  Typography,
} from '@repo/ui/components'
import Image from 'next/image'
import { useEffect } from 'react'

export const SuccessContainer = () => {
  const { t } = useTranslate()
  const { push } = useRouter()
  const { data: { data: authDetails } = {} } = useAgentAuthDetails()

  // Update kyc_reason and kyc_status cookies when KYC status changes
  useEffect(() => {
    const kyc = authDetails?.details?.kyc
    if (kyc) {
      const currentKycStatus = kyc.status || ''
      const currentKycComment = kyc.comment || ''
      // Update cookie if KYC comment/reason has changed
      if (currentKycStatus === 'waiting_for_review') {
        Cookie.set('kyc_status', currentKycStatus, {
          path: '/',
        })
        Cookie.set('kyc_reason', currentKycComment, {
          path: '/',
        })
        Cookie.remove('kyc_required')
        Cookie.remove('kyc_mobile_or_email')
      } else if (
        currentKycStatus === 'rejected' ||
        currentKycStatus === 'under_review'
      ) {
        Cookie.remove('kyc_required')
        Cookie.remove('kyc_mobile_or_email')
        push('/auth/rejected')
      } else if (currentKycStatus === 'approved') {
        Cookie.remove('kyc_reason')
        Cookie.remove('kyc_status')
        Cookie.remove('kyc_required')
        Cookie.remove('kyc_mobile_or_email')
        push('/dashboard')
      } else {
        Cookie.remove('kyc_reason')
        Cookie.remove('kyc_status')
        Cookie.remove('kyc_required')
        Cookie.remove('kyc_mobile_or_email')
        push('/')
      }
    }
  }, [authDetails, push])

  const handleLogout = () => {
    sessionStorage.removeItem('kyc_response')
    Cookie.removeAuthTokens()
    Cookie.remove('kyc_status')
    Cookie.remove('kyc_reason')
    push('/auth/login')
  }

  return (
    <Card className='p-xl rounded-sm'>
      <CenterBox className='h-full'>
        <Col className='gap-md items-center'>
          <CenterBox>
            <Image
              src='/images/hourglass.webp'
              alt='hourglass'
              width={80}
              height={80}
            />
          </CenterBox>

          <Typography
            size='md'
            weight='bold'
            color='text-alert-surface-100'
            className='text-center'
          >
            {t('success_title')}
          </Typography>
          <Typography
            size='md'
            color='text-neutral-surface-100'
            className='text-center'
          >
            {t('success_description')}
          </Typography>
          <Button
            variant='ghost'
            color='neutral'
            onClick={handleLogout}
            width='full'
            startIcon={<Icon name='ExitRightLine' size='sm' />}
          >
            {t('quickKyc_logout')}
          </Button>
        </Col>
      </CenterBox>
    </Card>
  )
}
